import CustomerAPI from 'api/customer';
import events from 'lib/events';
import PrintableSummary from '../../components/printableSummary';
import React from 'react';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

const currentYear = new Date().getFullYear();

class ReportSummary extends React.Component {
  state = {};

  export = () => {
    CustomerAPI.exportMissingInformationReport(
      this.props.intl.locale,
      this.props.filters.store, this.props.filters.systemType,
      this.props.filters.accountStatus, this.props.filters.missingInformation);
  };

  printReport = (data) => {
    var summary = data;
    let {formatMessage} = this.props.intl;
    const columns = [
      {name: formatMessage({id: 'reports.missing.contacts'}), key: 'Contacts'},
      {name: formatMessage({id: 'reports.missing.email'}), key: 'Emails'},
      {name: formatMessage({id: 'reports.missing.phone'}), key: 'Phones'},
      {name: formatMessage({id: 'reports.missing.adresses'}), key: 'Addresses'},
      {name: formatMessage({id: 'general.total.maintenance'}), key: 'SystemsOnMaintenance'},
    ];

    return (
      <PrintableSummary summary={summary}
                        columns={columns}
                        dateLabel={formatMessage({id: 'general.date'})}
                        date={'n/a'}
                        title={formatMessage({id: 'reports.customer.missing.information'})}/>
    );
  };

  columns = data => {
    return data.map((cart, i) =>
      <div className="col-sm-3"
           key={i}>
        {cart.title} <br/>
        <span>{cart.value}</span>
      </div>);
  };

  render() {
    let data = this.props.data;
    let {formatMessage} = this.props.intl;

    let summary = {
      lineOne: [
        {title: formatMessage({id: 'reports.missing.contacts'}), value: data.Contacts ? data.Contacts : 0},
        {title: formatMessage({id: 'reports.missing.email'}), value: data.Emails ? data.Emails : 0},
        {title: formatMessage({id: 'reports.missing.phone'}), value: data.Phones ? data.Phones : 0},
        {title: formatMessage({id: 'reports.missing.adresses'}), value: data.Addresses ? data.Addresses : 0},
      ],
      lineTwo: [
        {
          title: formatMessage({id: 'general.total.maintenance'}),
          value: data.SystemsOnMaintenance ? data.SystemsOnMaintenance : 0,
        },
      ],
    };

    return (
      <div>
        <div className="summary-container">
          <h2><FormattedMessage id="reports.report.summary"/></h2>
          <br/>
          <span><FormattedMessage id="reports.reveal.report.summary"/></span>
          {this.props.showNoDataMessage ?
            <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
          <div className="container-fluid">
            <div className={Object.keys(data).length ? 'row' : 'not-show'}
                 id="row-no-padding">
              {this.columns(summary.lineOne)}
            </div>
            <div className={Object.keys(data).length ? 'row' : 'not-show'}
                 id="row-no-padding">
              {this.columns(summary.lineTwo)}
            </div>
          </div>
        </div>
        <div className='col-sm-12 button-group shift-right'>
          <button className='btn btn-default pull-right'
                  disabled={Object.keys(data).length <= 0}
                  onClick={(() => {
                    events.publish('print', this.printReport(this.props.data));
                  })}><FormattedMessage id="reports.print.summary"/></button>
          <button className='btn btn-primary pull-right'
                  onClick={this.export}><FormattedMessage id="reports.export.report"/></button>
        </div>
      </div>
    );
  }
}

export default injectIntl(ReportSummary);
